import percentageDisplay from "../../../../components/percentageDisplay/percentageDisplay";
import { connect } from "react-redux";

export default connect(state => ({ value: Math.round(state.marketing.profileRetention.profilesToFirstVisit * 100) }))(percentageDisplay);
